module.exports = __webpack_public_path__ + "assets/img/loading-logo-en.3ae77dbb.png";